import React from "react";

export const ToggableLayoutContext = React.createContext({
  isSubmenuOpened: false,
  toggleSubmenu: () => {}
});

export const ToggableLayoutContextProvider = ToggableLayoutContext.Provider;
